import { cn } from "@/lib/utils";

/**
 * The construction-site motif that tops the sidebar and the Site Brain hero.
 * The design uses exactly two heights: 4px on the sidebar, 7px on the hero.
 */
export function HazardStripe({
  height = 4,
  className,
}: {
  height?: number;
  className?: string;
}) {
  return (
    <div
      aria-hidden
      className={cn("hazard-stripe w-full shrink-0", className)}
      style={{ height }}
    />
  );
}
